// @mui
import { Box, Divider, Grid, Skeleton, Stack } from '@mui/material';

// ----------------------------------------------------------------------

export default function CalendarScheduleSkeleton() {
  return (
    <Stack sx={{ padding: 3, paddingTop: 0, gap: 3, height: '100%' }}>
      {/* Weekday buttons skeleton */}
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: 3,
          flex: 1,
        }}
      >
        <Box
          sx={{
            width: 1,
            display: 'flex',
            gap: { xs: 1, sm: 1, md: 2, lg: 2 },
            justifyContent: 'space-between',
            mb: 2,
          }}
        >
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              sx={{
                flex: 1,
                height: 36,
                borderRadius: 1,
              }}
            />
          ))}
        </Box>

        {/* Time slots skeleton - showing 3 example days */}
        {[0, 1, 2].map((dayIndex) => (
          <Box key={dayIndex}>
            <Grid
              sx={{
                flexDirection: {
                  xs: 'column',
                  sm: 'column',
                  md: 'row',
                  lg: 'row',
                },
              }}
              container
              item
            >
              {/* Day label skeleton */}
              <Grid
                sx={{
                  mt: { xs: 0, sm: 0, md: 2, lg: 2, xl: 2 },
                  mb: { xs: 3, sm: 3, md: 3, lg: 0, xl: 0 },
                }}
                item
                lg={2}
              >
                <Skeleton variant="text" width={100} height={24} />
              </Grid>

              {/* Time slots container */}
              <Grid
                sx={{ flexDirection: 'column', gap: 2 }}
                xs={12}
                sm={12}
                md={12}
                lg={10}
                item
                container
              >
                {/* Time slot rows - showing 1 or 2 slots per day */}
                {(dayIndex === 1 ? [0, 1] : [0]).map((slotIndex) => (
                  <Grid
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                    item
                    container
                    key={slotIndex}
                  >
                    {/* Start time picker skeleton */}
                    <Skeleton
                      variant="rounded"
                      sx={{ flex: 1, height: 56, borderRadius: 1 }}
                    />

                    {/* Separator */}
                    <Box sx={{ marginX: 3 }}>-</Box>

                    {/* End time picker skeleton */}
                    <Skeleton
                      variant="rounded"
                      sx={{ flex: 1, height: 56, borderRadius: 1 }}
                    />

                    {/* Delete button skeleton */}
                    <Box sx={{ marginLeft: 3 }}>
                      <Skeleton variant="circular" width={40} height={40} />
                    </Box>
                  </Grid>
                ))}

                {/* Add slot button skeleton */}
                <Skeleton
                  variant="rounded"
                  width={195}
                  height={36}
                  sx={{ mt: 1, mb: 3, borderRadius: 1 }}
                />
              </Grid>
            </Grid>

            {/* Divider between days (except last) */}
            {dayIndex < 2 && <Divider sx={{ width: 1, mb: 3 }} />}
          </Box>
        ))}
      </Stack>

      {/* Action buttons skeleton */}
      <Stack flexDirection="column" marginTop={2} width={1}>
        <Box sx={{ width: 1, display: 'flex', gap: 2, justifyContent: 'end' }}>
          {/* Cancel button skeleton */}
          <Skeleton
            variant="rounded"
            width={124}
            height={36}
            sx={{ borderRadius: 1 }}
          />
          {/* Save button skeleton */}
          <Skeleton
            variant="rounded"
            width={75}
            height={36}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Stack>
    </Stack>
  );
}
